import React from 'react'
import { WithEntity } from './types'
import { MainProductAPIEntity } from 'services/api/entities'
import { useKGetList } from 'services/hooks/useKGetList'
import ProductPackageBaseFormContent, {
  GenericChoiceTailored,
} from './ProductPackageBaseFormContent'
import { yupResolver } from '@hookform/resolvers/yup'
import { AnyObjectSchema } from 'yup'
import { KSimpleForm } from 'ui-shared/WrappedInputs/KSimpleForm'

type Props = WithEntity<MainProductAPIEntity> & {
  defaultBundleSetting?: boolean
  isToggleBundleVisible?: boolean
  linkedRulesPanel?: JSX.Element
  presetInputFields?: React.ReactElement
  validationSchema: AnyObjectSchema
}

const ProductPackageBaseFormProvider: React.FC<Props> = ({
  entity,
  validationSchema,
  ...props
}) => {
  const productChoices = useKGetList<GenericChoiceTailored>(entity)
  if (!productChoices.length) return null

  return (
    <KSimpleForm {...props} resolver={yupResolver(validationSchema)}>
      <ProductPackageBaseFormContent
        choices={productChoices}
        showAllPkgs
        {...props}
      />
    </KSimpleForm>
  )
}

export default ProductPackageBaseFormProvider
